"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useMemo } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { MatchList } from "@/components/matches";
import { mapMatchToMatchListItem } from "@/utilities/mappers/match";
import { useTeamLogoUrl } from "@/components/ui/TeamLogo";
import { useLabels } from "@/lib/labels/LabelsProvider";
import { useNavigation } from "@/lib/navigation/NavigationProvider";
import type { MatchRow } from "@/utilities/data/competition/derive/types";
interface GroupMatchesProps {
  /** The group's matches, already filtered and sorted by kickoff ascending. */
  matches: MatchRow[];
}

/**
 * Toggleable match list for an international competition group.
 * Renders with odds support for upcoming matches via MatchList.
 */
export function GroupMatches(t0) {
  const $ = _c(23);
  const {
    matches
  } = t0;
  const labels = useLabels();
  const nav = useNavigation();
  const [expanded, setExpanded] = useState(false);
  const resolveLogoUrl = useTeamLogoUrl();
  let t1;
  if ($[0] !== matches || $[1] !== nav.match || $[2] !== resolveLogoUrl) {
    let t2;
    if ($[4] !== nav.match || $[5] !== resolveLogoUrl) {
      t2 = m => {
        const isFinished = m.status.type === "FINISHED" || new Date(m.timing.kickoffTime) <= new Date();
        return mapMatchToMatchListItem(m, isFinished, false, nav.match, resolveLogoUrl);
      };
      $[4] = nav.match;
      $[5] = resolveLogoUrl;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = matches.map(t2);
    $[0] = matches;
    $[1] = nav.match;
    $[2] = resolveLogoUrl;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const matchItems = t1;
  if (matches.length === 0) {
    return null;
  }
  let t2;
  if ($[7] !== expanded) {
    t2 = () => setExpanded(!expanded);
    $[7] = expanded;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== expanded) {
    t3 = expanded ? <ChevronUp className="size-4" /> : <ChevronDown className="size-4" />;
    $[9] = expanded;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== labels.matches.title || $[12] !== matches.length || $[13] !== t2 || $[14] !== t3) {
    t4 = <button onClick={t2} className="flex items-center justify-center gap-2 w-full py-2 text-sm font-semibold text-muted-foreground hover:text-foreground transition-colors cursor-pointer border border-border rounded-md bg-muted hover:bg-muted/50">{t3}{labels.matches.title} ({matches.length})</button>;
    $[11] = labels.matches.title;
    $[12] = matches.length;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== expanded || $[17] !== labels.matches.noMatchFound || $[18] !== matchItems) {
    t5 = expanded && <div className="mt-4"><MatchList matches={matchItems} variant="teamFixtures" emptyMessage={labels.matches.noMatchFound} /></div>;
    $[16] = expanded;
    $[17] = labels.matches.noMatchFound;
    $[18] = matchItems;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== t4 || $[21] !== t5) {
    t6 = <div className="mt-4">{t4}{t5}</div>;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  return t6;
}